<script>
import CKEditor from "@ckeditor/ckeditor5-vue";

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript";
import subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript";
import strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import Indent from "@ckeditor/ckeditor5-indent/src/indent";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock";

export default {
  name: "CKEditor",
  props: ["disabled", "toolbar"],
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component,
  },
  methods: {
    onChange() {
      this.$emit("onChange");
    },
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          BoldPlugin,
          ItalicPlugin,
          Underline,
          Superscript,
          subscript,
          strikethrough,
          Alignment,
          Indent,
          IndentBlock,
          EssentialsPlugin,
          ParagraphPlugin,
        ],
        toolbar: this.toolbar,
        indentBlock: {
          offset: 1,
          unit: "em",
        },
      },
      errors: this.p_errors,
      errors_msg: this.p_errors_msg,
    };
  },
};
</script>

<template>
  <ckeditor
    @input="onChange"
    tag-name="textarea"
    :editor="editor"
    :config="editorConfig"
    :disabled="this.disabled"
  ></ckeditor>
</template>
